﻿<script>
  export let className;
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="26"
  height="26"
  viewBox="0 0 26 26"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  class={className}>
  <g transform="translate(1.000000, 1.000000)">
    <path
      d="M5.5,11.5 C5.225,11.5 5.159,11.659 5.354,11.854 L11.646,18.147
      C11.7398441,18.2413486 11.8674272,18.2943958 12.0005,18.2943958
      C12.1335728,18.2943958 12.2611559,18.2413486 12.355,18.147 L18.666,11.872
      C18.866,11.679 18.796,11.519 18.521,11.517 L15.5,11.5 L15.5,1.5
      C15.5,0.94771525 15.0522847,0.5 14.5,0.5 L9.5,0.5 C8.94771525,0.5
      8.5,0.94771525 8.5,1.5 L8.5,11 C8.5,11.2761424 8.27614237,11.5 8,11.5
      L5.5,11.5 Z"
      id="Path" />
    <path
      d="M23.5,18.5 L23.5,22.5 C23.5,23.0522847 23.0522847,23.5 22.5,23.5
      L1.5,23.5 C0.94771525,23.5 0.5,23.0522847 0.5,22.5 L0.5,18.5"
      id="Path" />
  </g>
</svg>
